var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "allBox" }, [
    _c(
      "div",
      { staticClass: "allBoxTitle" },
      [
        _c("h3", { staticClass: "allTitle" }, [
          _vm._v(_vm._s(_vm.$t("DakaNews")))
        ]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: { path: "/info" } } }, [
          _vm._v(_vm._s(_vm.$t("ViewMore")))
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.list != null
      ? _c(
          "ul",
          { staticClass: "hotinformation" },
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "li",
              { key: index },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        path:
                          "/info/item/" +
                          item._id +
                          "?i=" +
                          index +
                          "&p=" +
                          _vm.pi
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "hotinformationimg" }, [
                      _c("img", {
                        attrs: { src: item.ImgUrl + "?imageView2/2/h/360" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hotinformationText" }, [
                      _c("p", { staticClass: "line_txt1" }, [
                        _vm._v(_vm._s(item.Title))
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45b9d79b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b9d79b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/hotinformation.vue
// module id = null
// module chunks = 